// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-navigation-hint[data-v-a5d0b7b2]{color:var(--color-text-maxcontrast);line-height:44px;list-style-type:none;white-space:nowrap;text-overflow:ellipsis;box-shadow:none !important;user-select:none;pointer-events:none;padding-left:10px}\n", ""]);
// Exports
module.exports = exports;
